document.addEventListener("DOMContentLoaded", () => {
  class subscriptionForm extends HTMLElement {
    constructor() {
      super();
      this.variantData = JSON.parse(this.querySelector("#subscription-json").textContent);
      this.productSection = this.closest(".product-section");
      this.variants = this.querySelectorAll(".subscription__variant");
      this.plans = this.querySelectorAll(".subscription__selling-plan");
      this.customPlan = this.querySelector(".subscription__selling-custom-plan");
      this.currentSellingType = this.querySelector(".subscription-tab.active").dataset.sellingType;
      this.variantJson = this.parseVariantJson();
      this.initInputs();
      this.plans.forEach((plan) =>
        plan.addEventListener("click", this.changePlan.bind(this, plan))
      );
      this.variants.forEach((variant) =>
        variant.addEventListener("click", this.changeVariant.bind(this, variant))
      );
      this.querySelectorAll(".subscription-tab").forEach((tab) => {
        tab.addEventListener("click", this.changeType.bind(this, tab));
        if (tab.dataset.sellingType === "subscribe") {
          this.subscriptionTab = tab;
        }
      });
      this.customPlan?.addEventListener("click", this.initCustomPlan.bind(this));
      this.syncMainVariant(this.dataset.variantId);
      this.updatePrice();
    }

    parseVariantJson() {
      const variantJsonEl = this.productSection?.querySelector("[data-variant-json]");
      if (!variantJsonEl) return [];

      try {
        return JSON.parse(variantJsonEl.textContent || "[]");
      } catch (error) {
        return [];
      }
    }

    changeType(tab) {
      this.querySelectorAll(".subscription-tab").forEach((subtab) => {
        subtab.classList.remove("active");
      });
      tab.classList.add("active");
      this.currentSellingType = tab.dataset.sellingType;
      if (this.currentSellingType === "once") {
        this.sellingPlanInput.value = "";
        this.setAttribute("data-selling-type", "once");
      } else {
        this.removeAttribute("data-selling-type");
        this.plans.forEach((plan) => {
          if (plan.classList.contains("active"))
            this.sellingPlanInput.value = plan.dataset.sellingPlanId;
        });
      }

      this.updatePrice();
    }

    getActiveVariantId() {
      return (this.productVariantInput && this.productVariantInput.value) || this.dataset.variantId;
    }

    getActiveVariantData() {
      const activeVariantId = this.getActiveVariantId();
      const byVariant = this.variantData && this.variantData[activeVariantId];
      if (!byVariant) return null;

      if (this.currentSellingType === "subscribe") {
        return byVariant.subscribe && byVariant.subscribe[this.sellingPlanInput.value];
      }

      return byVariant.once;
    }

    syncStickyPrice() {
      const activeVariantData = this.getActiveVariantData();
      if (!activeVariantData || !activeVariantData.price) return;

      document.querySelectorAll("[data-sticky-price]").forEach((priceEl) => {
        const hasComparePrice =
          activeVariantData.compare_at_price &&
          activeVariantData.compare_at_price !== activeVariantData.price;

        priceEl.innerHTML = `
          <span class="sticky-atc__price-current">${activeVariantData.price}</span>
          ${hasComparePrice ? `<span class="sticky-atc__price-compare">${activeVariantData.compare_at_price}</span>` : ""}
        `;
      });
    }

    syncMainVariant(variantId) {
      const variantSelect = this.productSection?.querySelector("[data-product-select]");
      const selectedVariant =
        this.variantJson.find((variant) => String(variant.id) === String(variantId)) || null;

      if (variantSelect) {
        const nextVariantId = String(variantId);
        if (variantSelect.value !== nextVariantId) {
          variantSelect.value = nextVariantId;
        }

        variantSelect.dispatchEvent(new Event("change", { bubbles: true }));
      }

      if (!this.productSection || !selectedVariant) return;

      const variantDetail = { detail: { variant: selectedVariant } };
      this.productSection.dispatchEvent(new CustomEvent("variantChange", variantDetail));
      this.productSection.dispatchEvent(new CustomEvent("variantPriceChange", variantDetail));
      this.productSection.dispatchEvent(new CustomEvent("variantImageChange", variantDetail));
      this.productSection.dispatchEvent(new CustomEvent("variantUnitPriceChange", variantDetail));
      this.productSection.dispatchEvent(new CustomEvent("variantSKUChange", variantDetail));
    }

    updatePrice() {
      this.variants.forEach((variant, index) => {
        const price = variant.querySelector(".subscription__variant-price");
        const discount = variant.querySelector(".subscription__variant-discount");
        const compare = variant.querySelector(".subscription__variant-compare_price");

        let variantData = this.variantData[variant.dataset.variantId][this.currentSellingType];
        if (this.currentSellingType === "subscribe") {
          variantData = variantData[this.sellingPlanInput.value];
        }

        if (!variantData) return;

        price.innerHTML = variantData.price;
        if (variantData.discount != "") {
          discount.innerHTML = variantData.discount;
          discount.classList.remove("hidden");
        } else {
          discount.classList.add("hidden");
        }

        if (!compare) return;

        compare.innerHTML = variantData.compare_at_price;
        compare.classList.toggle("hidden", variantData.price === variantData.compare_at_price);
      });

      // Keep the Subscribe tab text in sync with the currently selected variant + plan
      if (this.currentSellingType === "subscribe" && this.subscriptionTab) {
        const activeVariantId =
          (this.productVariantInput && this.productVariantInput.value) || this.dataset.variantId;
        const byVariant = this.variantData && this.variantData[activeVariantId];
        const byPlan = byVariant && byVariant.subscribe && byVariant.subscribe[this.sellingPlanInput.value];
        if (byPlan && byPlan.tab_text) {
          this.subscriptionTab.innerHTML = byPlan.tab_text;
        }
      }

      this.syncStickyPrice();
    }

    changeVariant(currentVariant) {
      this.productVariantInput.value = currentVariant.dataset.variantId;
      this.variants.forEach((variant) => variant.classList.remove("active"));
      currentVariant.classList.add("active");
      this.syncMainVariant(currentVariant.dataset.variantId);
      this.updatePrice();
    }

    changePlan(currentPlan) {
      this.sellingPlanInput.value = currentPlan.dataset.sellingPlanId;
      this.plans.forEach((plan) => plan.classList.remove("active"));
      currentPlan.classList.add("active");
      this.updatePrice();
    }

    initCustomPlan() {
      this.classList.add("custom-plan-open");
      this.controlButtons = this.querySelectorAll("[data-control-plan]");
      this.currentPlanId = 0;
      this.changePlan(this.plans[0]);
      this.controlButtons.forEach((button) => {
        button.addEventListener("click", this.swipePlan.bind(this, button));
      });
    }

    swipePlan(button) {
      this.controlButtons.forEach((controlButton) => {
        if (controlButton.dataset.controlPlan != button.dataset.controlPlan)
          controlButton.classList.remove("disabled");
      });

      const step = button.dataset.controlPlan == "next" ? 1 : -1;
      if (this.currentPlanId + step >= this.plans.length || this.currentPlanId + step < 0) {
        return;
      }
      if (this.currentPlanId + step < this.plans.length || this.currentPlanId + step > 0) {
        this.currentPlanId += step;
      }
      if (this.currentPlanId >= this.plans.length - 1 || this.currentPlanId <= 0) {
        button.classList.add("disabled");
      }

      this.plans.forEach((variant) => {
        variant.classList.add("hidden");
        variant.classList.remove("show");
      });
      this.plans[this.currentPlanId].classList.remove("hidden");
      this.plans[this.currentPlanId].classList.add("show");
      this.changePlan(this.plans[this.currentPlanId]);
    }

    initInputs() {
      const productForm =
        this.closest(".product-single__meta").querySelector(".product-single__form");
      const inputs = `<input type="hidden" id="subscription_selling_plan" name="selling_plan" value="${this.dataset.sellingPlanId}">
                                <input id="subscription_product_id" type="hidden" name="id" value="${this.dataset.variantId}">`;
      if (!productForm) {
        return;
      }
      productForm.innerHTML += inputs;
      this.sellingPlanInput = productForm.querySelector("#subscription_selling_plan");
      this.productVariantInput = productForm.querySelector("#subscription_product_id");
    }
  }

  customElements.define("subscribe-form", subscriptionForm);
});
